import * as React from "react";
import { Check } from "lucide-react";

import { cn } from "@/lib/utils";

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  indeterminate?: boolean;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, indeterminate, checked, ...props }, ref) => {
    const inner = React.useRef<HTMLInputElement>(null);
    React.useImperativeHandle(ref, () => inner.current!);
    React.useEffect(() => {
      if (inner.current) inner.current.indeterminate = !!indeterminate;
    }, [indeterminate]);

    return (
      <label className="relative inline-flex h-4 w-4 cursor-pointer items-center justify-center">
        <input
          ref={inner}
          type="checkbox"
          checked={checked}
          className={cn(
            "peer h-4 w-4 shrink-0 cursor-pointer appearance-none rounded border border-input bg-background transition-colors checked:border-primary checked:bg-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            className,
          )}
          {...props}
        />
        {(checked || indeterminate) && (
          <Check className="pointer-events-none absolute h-3 w-3 text-primary-foreground" />
        )}
      </label>
    );
  },
);
Checkbox.displayName = "Checkbox";
